import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { overrideConsole, generateSessionID } from './loggers/logger';

// Initialize remote logging silently
generateSessionID() //always do this at start of app
  .then( (id) => { overrideConsole()
    .then(() => {
      createRoot(document.getElementById('root')!).render(
        <StrictMode>
          <App />
        </StrictMode>
      );
    })
    .catch(error => {
      console.log(`Remote logger not found, proceeding normally from error: ${error}`);
      createRoot(document.getElementById('root')!).render(
        <StrictMode>
          <App />
        </StrictMode>
      );
    });
  });

